import { Link, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/404')({
  component: NotFoundRoute,
});

function NotFoundRoute() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-parchment px-6">
      <div className="max-w-md text-center">
        <h1 className="font-serif text-4xl text-ink">Lost the thread?</h1>
        <p className="mt-6 font-sans text-base text-ink/70 pretty">
          The page you&apos;re looking for isn&apos;t here. It may have moved or been removed.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-md bg-ink px-4 py-2 font-sans text-sm font-medium text-parchment hover:bg-oxblood"
        >
          Homepage
        </Link>
      </div>
    </div>
  );
}
